interface SearchResultItemResponseProps{
    generatedTextWithCitations: (string | SearchResultCitation)[] | undefined;
    handleSelectedReference: (reference: SearchResultCitation) => void
 }

export const SearchResultItemResponse: React.FC<SearchResultItemResponseProps> = (props: SearchResultItemResponseProps) => {
    const formatGeneratedText = (generatedTextWithCitations: (string | SearchResultCitation)[] | undefined) => {
        if (!generatedTextWithCitations) return;
        function generateBreaklines(numberOfLines: number) {
            if (typeof numberOfLines !== 'number' || numberOfLines < 0) {
              return <></>; 
            }
          
            const breaklines = [];
            for (let i = 0; i < numberOfLines; i++) {
              breaklines.push(<br key={"b"+i} />);
            }
          
            return <>{breaklines}</>;
        }
        let breaklinesCnt = 0
        
        return generatedTextWithCitations.map((item, item_index) => {
            if (typeof item === "string") {
                const lines = item.split('\n');
                return lines.map((line, index) => {
                    if(line.length > 0){ 
                        const noOfLines = breaklinesCnt
                        breaklinesCnt = 0
                        return <span key={`${item_index}_${index}`}>{noOfLines> 0 && generateBreaklines(noOfLines)}{line} {lines.length !== index + 1 && <br />}</span> 
                    }else{
                        breaklinesCnt++  
                        //return <br key={`${item_index}_${index}`} />
                    }
                });
            } else {
                // Citation - open modal directly on click
                const noOfLines = breaklinesCnt
                breaklinesCnt = 0
                return (
                    <span 
                        key={item.no} 
                        className='cur-pointer c-primary' 
                        onClick={() => props.handleSelectedReference(item)}
                    >
                        [{item.no}]
                        {breaklinesCnt> 0 && generateBreaklines(noOfLines) }
                    </span>
                );
            }
        });
    };

    return (
        <>{formatGeneratedText(props.generatedTextWithCitations)}</>
    )
}